import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';

export const useTowerSocket = (rootPath) => {
    const EMIT_TOWER_BET = async (
        data: {
            amount?: string;
            difficulty?: number;
            type: number; // type 0 is prebet 1 is bet
            prediction?: number; // only type be 1 will pass in ;
            frontID?: number;
            isFast: boolean;
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        const result = await asyncEmit<{
            [key: string]: any; // 前端将追加其它值
            fields: Array<Array<number>>;
            multi: number;
            win: boolean;
            winAmount: number;
            status: any;
        }>(`${rootPath}.tower.bet`, data);

        return {
            ...result,
            winAmount: result?.winAmount ? result?.winAmount : 0,
        };
    };

    return {
        EMIT_TOWER_BET,
    };
};
